import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useRecordContext } from "ra-core";

import useTierInfo from "../../../hooks/useTierInfo";

const useStyles = makeStyles(() => ({
  container: {
    marginTop: 10,
    marginBottom: 15,
  },
}));

const PriviledgeField = (props) => {
  const classes = useStyles();
  const record = useRecordContext(props);
  const { loading, tier, error } = useTierInfo(record.id);

  if (loading) return null;
  if (error) {
    return null;
  }

  return (
    <>
      <Typography variant="h4"> Privileges </Typography>
      <Table className={classes.container}>
        <TableHead>
          <TableCell>Condition Name</TableCell>
          <TableCell>Value</TableCell>
          <TableCell>Reward Name</TableCell>
          <TableCell>Value</TableCell>
        </TableHead>

        {record.privileges?.map((pri, index) => {
          return (
            <TableRow>
              <TableCell>
                {tier.privileges[index].condition.getMessage()}
              </TableCell>
              <TableCell>{pri.condition.value}</TableCell>
              <TableCell>
                {tier.privileges[index].coupon.getMessage()}
              </TableCell>
              <TableCell>{pri.item.value}</TableCell>
            </TableRow>
          );
        })}
      </Table>
    </>
  );
};

/*
const AuthorizeContent = ({ record }) => {
  const classes = useStyles();
  return (
    <>
      <Typography variant="h4"> Authorized </Typography>
      <Table className={classes.container}>
        <TableHead>
          <TableCell>Authorize</TableCell>
          <TableCell>Actions</TableCell>
        </TableHead>

        {record.authorizes.map((auth) => {
          return (
            <TableRow>
              <TableCell>{auth.object_code}</TableCell>
              {auth.action_codes.map((act) => (
                <TableCell>{act}</TableCell>
              ))}
            </TableRow>
          );
        })}
      </Table>
    </>
  );
};*/
export default PriviledgeField;
